var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('el-row',[_c('el-col',{staticStyle:{"text-align":"right"},attrs:{"offset":12,"span":10}},[(_vm.showDownload)?_c('el-button',{staticStyle:{"margin":"10px"},attrs:{"type":"primary","size":"small"},on:{"click":_vm.download}},[_vm._v("下载报表")]):_vm._e()],1)],1),_c('div',{ref:"vizContainer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }